import React, { ReactNode, useEffect } from "react";

import { useNavigate } from "react-router-dom";

interface Props {
  children: ReactNode;
}

const NavigationProvider: React.FC<Props> = (props) => {
  const { children } = props;
  const navigate = useNavigate();

  useEffect(() => {
    const onRouteHandler = (e: CustomEvent<RouteCustomEvent>) => {
      const detail = e?.detail;

      if (!detail) throw new Error('The "detail" should be not NULL!');

      const { path, type, params, state } = detail;
      const search = params
        ? new URLSearchParams(params as unknown as URLSearchParams).toString()
        : "";
      const to = path + (search ? `?${search}` : "");

      switch (type) {
        case "push": {
          navigate(to, { state });
          break;
        }
        case "replace": {
          navigate(to, { replace: true, state });
          break;
        }
        case "goBack": {
          navigate(-1);
          break;
        }
        default:
          break;
      }
    };

    window.addEventListener("route", onRouteHandler);

    return () => {
      window.removeEventListener("route", onRouteHandler);
    };
  }, [navigate]);

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>;
};

export default NavigationProvider;
